import { render, staticRenderFns } from "./ModalTip.vue?vue&type=template&id=8202a0d4&"
import script from "./ModalTip.vue?vue&type=script&lang=js&"
export * from "./ModalTip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports